export class ResendVerificationDTO {
  email: string;
  fullName: string;

  constructor(email: string, fullName: string) {
    this.email = email;
    this.fullName = fullName;
  }
}
